// Use this constant to identify the Rovo AI panel in Jira
export const JIRA_ROVO_AI_PANEL_ID = 'jira-rovo-ai-panel';

// Default width for the Rovo AI panel in pixels
export const JIRA_ROVO_AI_PANEL_WIDTH = 400; // px
